import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import SportPage from "@/pages/SportPage";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import SportAdminPage from "@/pages/SportAdminPage";
import SiteSettingsPage from "@/pages/SiteSettingsPage";
import SearchPage from "@/pages/SearchPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ThemeApplier from "@/components/ThemeApplier";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import ForcePasswordGate from "@/components/ForcePasswordGate";
import HelpPage from "@/pages/HelpPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#F8F9FA]">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <ThemeApplier />
          <ForcePasswordGate>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/sports/:slug" element={<SportPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/admin/sports" element={<SportAdminPage />} />
            <Route path="/admin/site" element={<SiteSettingsPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/help" element={<HelpPage />} />
          </Routes>
          </ForcePasswordGate>
          <Footer />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
